import React from "react";
import { Helmet } from "react-helmet-async";

interface SEOProps {
  title?: string;
  description?: string;
  // canonical?: string;
  // image?: string;
  // ogTitle?: string;
  // ogDescription?: string;
  // ogImage?: string;
  // ogUrl?: string;
  // siteName?: string;
  // keywords?: string;
  // author?: string;
  // type?: string;
  // locale?: string;
}

export const SEO: React.FC<SEOProps> = ({
  title,
  description,
  // canonical,
  // image,
  // ogTitle,
  // ogDescription,
  // ogImage,
  // ogUrl,
  // siteName = 'Your Site Name',
  // keywords,
  // author,
  // type = 'website',
  // locale = 'en_US',
}) => {
  // Use og values as fallbacks
  const metaTitle = title;
  const metaDescription = description;
  // const metaImage = image || ogImage;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      {metaTitle && <title>{metaTitle}</title>}
      {metaDescription && <meta name="description" content={metaDescription} />}
      {/* {keywords && <meta name="keywords" content={keywords} />}
      {author && <meta name="author" content={author} />}
      {canonical && <link rel="canonical" href={canonical} />} */}

      {/* Open Graph Meta Tags */}
      {/* <meta property="og:title" content={ogTitle || "EuCalls - European Funding Platform"} />
      <meta property="og:description" content={ogDescription || "Discover and apply for European funding opportunities through EuCalls platform"} />
      <meta property="og:type" content="website" />
      <meta property="og:url" content={ogUrl || "https://app.eucalls.net"} />
      <meta property="og:image" content={ogImage || "https://app.eucalls.net/icons/eucalls-meta-image.webp"} />
      <meta property="og:image:width" content="1200" />
      <meta property="og:image:height" content="675" /> */}
      {/* <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={locale} /> */}

      {/* Twitter Card Meta Tags */}
      {/* <meta name="twitter:card" content="summary_large_image" />
      {metaTitle && <meta name="twitter:title" content={metaTitle} />}
      {metaDescription && (
        <meta name="twitter:description" content={metaDescription} />
      )} */}
      {/* {metaImage && <meta name="twitter:image" content={metaImage} />} */}
    </Helmet>
  );
};
